import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect } from 'react';
import { HttpAgent } from '../../../utility/HttpAgent';
import AuthContext from '../../../ms_authentication/context/AuthContext';
import rootStore from '../../../stores/rootStore';
import DatasetData from '../../dataset/data/DatasetData';

const Data = () => {
  const { dialogStore, datasetStore } = useContext(rootStore);
  const { authenticated, loading: userLoading } = useContext(AuthContext);

  const load = async () => {
    await Promise.all([dialogStore.loadBots(), datasetStore.load()]);
  };

  useEffect(() => {
    if (!userLoading && authenticated) load();

    return HttpAgent.cancelRequest;
  }, [authenticated, userLoading]);

  return <DatasetData />;
};

export default observer(Data);
